import { css } from "@emotion/react"
import { HorizontalRule } from "source/giving/components/HorizontalRule"
import { useMediaQuery } from "source/giving/hooks/useMediaQuery"
import { BREAKPOINTS } from "source/shared/hooks/useWindowDimensions"
import { useDonationFormContext } from "../hooks/useDonationFormContext"
import { Designation, Frequency, StripePaymentMethod } from "../types"
import { CoverTheFee } from "./CoverTheFee"
import { DonationSummary } from "./DonationSummary"
import { PaymentMethodSelector } from "./PaymentMethodSelector"

type RightPaneProps = {
  designations: Designation[]
  desktop: boolean
  totalCents: number
  frequency: Frequency
  stripePaymentMethod?: StripePaymentMethod
  savePaymentMethodChecked: boolean
  feeCovered: boolean
}
export function RightPane({
  designations = [],
  desktop,
  totalCents,
  frequency,
  stripePaymentMethod,
  savePaymentMethodChecked,
  feeCovered,
}: RightPaneProps) {
  const { config } = useDonationFormContext()
  const showCTF =
    config.fee_coverage_allowed &&
    config.fee_rates !== null &&
    !!stripePaymentMethod
  const isMobile = useMediaQuery(`(max-width: ${BREAKPOINTS.MD - 1}px)`)

  return (
    <div
      className="f-1 d-f fd-c g-3"
      css={css`
        flex-basis: 400px;
      `}
    >
      {!desktop && (
        <DonationSummary {...{ designations, totalCents, frequency }} />
      )}
      <PaymentMethodSelector
        {...{ frequency, stripePaymentMethod, savePaymentMethodChecked }}
      />
      {isMobile && <HorizontalRule />}
      {showCTF && (
        <CoverTheFee {...{ designations, feeCovered, stripePaymentMethod }} />
      )}
    </div>
  )
}
